/*
 * @Descripttion:
 * @version:
 * @Author: linxi
 * @email: 2194421430@qq.com
 * @Date: 2023-11-16 18:06:31
 * @LastEditors: linxi
 * @LastEditTime: 2023-12-15 15:31:31
 */
import { unwrapResult } from '@reduxjs/toolkit'
import { Button, Col, notification, Row, Space } from 'antd'
import moment from 'moment'
import React, { forwardRef, ReactElement, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { Label } from '../../../compnents/widgets/Label'
import { BDJSColumns, ELSEColumns } from './columns'
import { serverType } from '../../../services/commodity'
import { useQuery } from '../../../utils/HttpUtils'
import {
  noCardRefundAsync,
  selfDetailedReconciliationOfSettlementInfoAsync,
  selfDetailedReconciliationOfSettlementInfoExportAsync,
} from '../ReconciliationSlice'
import {
  selectInsuranceArray,
  selectUserName,
  selectUserId,
  selectTenantAddress,
  selectTenantAreaCd,
  selectTenantName,
  selectTenantCategory,
} from '../../../app/applicationSlice'
import {
  selectInsuranceItem,
  setInsurance,
} from '../../../layouts/insuranceSlice'
import { strParse, medicalSendHttp } from '../../../utils/MedicalUtils'
import { DateTimeFormatSimpleOnlyOne } from '../../../models/datetime'

interface DetailReconciliationProps {
  tabKey?: any
}

const RealDetailReconciliations = ({
  tabKey,
}: DetailReconciliationProps): ReactElement => {
  const dispatch = useDispatch<RootDispatch>()

  const query = useQuery()

  const accountDate = query.get('accountDate') as any

  const insuranceArray = useSelector(selectInsuranceArray)

  const userName = useSelector(selectUserName)

  const userId = useSelector(selectUserId)

  const tenantAddress = useSelector(selectTenantAddress)

  const tenantAreaCd = useSelector(selectTenantAreaCd)

  const tenantName = useSelector(selectTenantName)

  const baseData = useSelector(selectInsuranceItem)

  const cycleCode = sessionStorage.getItem('cycleCode')

  const tenantCategory = useSelector(selectTenantCategory)

  const [insuranceItem, setInsuranceItem] = useState<any>()

  const [dataLoading, setDataLoading] = useState(false)

  const [params, setParams] = useState<any>({ current: 0, size: 10 })

  const [pageList, setPageList] = useState<any>()

  const [pageLoading, setPageLoading] = useState(false)

  //测试代码
  // useEffect(() => {
  //   const info = JSON.parse('{"infcode":"0","inf_refmsgid":"null","refmsg_time":"20240617180309174","respond_time":"20240617180309329","enctype":"","signtype":"","err_msg":null,"output":{"compareMoreList":null,"compareEqualList":null,"compareLessList":[{"insu_admdvs":"320599","medfee_sumamt":-23.6,"refd_setl_flag":"","inscp_amt":-6,"mdtrt_id":"32050000000002552039","med_type":"11","fund_pay_sumamt":-4.8,"acct_pay":0,"fix_blng_admdvs":null,"memo":"定点医疗机构不存在该结算数据","setl_id":"320500000000000000000002153014","insutype":"310","stmt_rslt":"1","psn_no":"32059900000000000291603780","psn_type":"1101","setl_date":"20240617"},{"insu_admdvs":"320599","medfee_sumamt":17.6,"refd_setl_flag":"1","inscp_amt":null,"mdtrt_id":"32050000000002551012","med_type":"11","fund_pay_sumamt":4.8,"acct_pay":0,"fix_blng_admdvs":null,"memo":"该结算数据已经对过账，且平账","setl_id":"320500000000000000000002152002","insutype":"310","stmt_rslt":"0","psn_no":"32059900000000000291603780","psn_type":"1101","setl_date":"20240617"},{"insu_admdvs":"320599","medfee_sumamt":17.6,"refd_setl_flag":"1","inscp_amt":null,"mdtrt_id":"32050000000002552014","med_type":"11","fund_pay_sumamt":4.8,"acct_pay":0,"fix_blng_admdvs":null,"memo":"该结算数据已经对过账，且平账","setl_id":"320500000000000000000002152003","insutype":"310","stmt_rslt":"0","psn_no":"32059900000000000291603780","psn_type":"1101","setl_date":"20240617"},{"insu_admdvs":"320582","medfee_sumamt":13.2,"refd_setl_flag":"1","inscp_amt":null,"mdtrt_id":"32050000000002551014","med_type":"11","fund_pay_sumamt":2.93,"acct_pay":0,"fix_blng_admdvs":null,"memo":"该结算数据已经对过账，且平账","setl_id":"320500000000000000000002152004","insutype":"390","stmt_rslt":"0","psn_no":"32059900000000000061284406","psn_type":"1501","setl_date":"20240617"},{"insu_admdvs":"320582","medfee_sumamt":-13.2,"refd_setl_flag":"1","inscp_amt":null,"mdtrt_id":"32050000000002551014","med_type":"11","fund_pay_sumamt":-2.93,"acct_pay":0,"fix_blng_admdvs":null,"memo":"该结算数据已经对过账，且平账","setl_id":"320500000000000000000002153002","insutype":"390","stmt_rslt":"0","psn_no":"32059900000000000061284406","psn_type":"1501","setl_date":"20240617"},{"insu_admdvs":"320599","medfee_sumamt":-17.6,"refd_setl_flag":"1","inscp_amt":null,"mdtrt_id":"32050000000002552014","med_type":"11","fund_pay_sumamt":-4.8,"acct_pay":0,"fix_blng_admdvs":null,"memo":"该结算数据已经对过账，且平账","setl_id":"320500000000000000000002153003","insutype":"310","stmt_rslt":"0","psn_no":"32059900000000000291603780","psn_type":"1101","setl_date":"20240617"},{"insu_admdvs":"320599","medfee_sumamt":-17.6,"refd_setl_flag":"1","inscp_amt":null,"mdtrt_id":"32050000000002551012","med_type":"11","fund_pay_sumamt":-4.8,"acct_pay":0,"fix_blng_admdvs":null,"memo":"该结算数据已经对过账，且平账","setl_id":"320500000000000000000002153004","insutype":"310","stmt_rslt":"0","psn_no":"32059900000000000291603780","psn_type":"1101","setl_date":"20240617"},{"insu_admdvs":"320582","medfee_sumamt":19.2,"refd_setl_flag":"0","inscp_amt":null,"mdtrt_id":"32050000000002551016","med_type":"11","fund_pay_sumamt":2.93,"acct_pay":0,"fix_blng_admdvs":null,"memo":"该结算数据已经对过账，且平账","setl_id":"320500000000000000000002153005","insutype":"390","stmt_rslt":"0","psn_no":"32059900000000000061284406","psn_type":"1501","setl_date":"20240617"},{"insu_admdvs":"320582","medfee_sumamt":13.2,"refd_setl_flag":"0","inscp_amt":null,"mdtrt_id":"32050000000002551025","med_type":"11","fund_pay_sumamt":2.93,"acct_pay":0,"fix_blng_admdvs":null,"memo":"该结算数据已经对过账，且平账","setl_id":"320500000000000000000002152007","insutype":"390","stmt_rslt":"0","psn_no":"32059900000000000061284406","psn_type":"1501","setl_date":"20240617"},{"insu_admdvs":"320507","medfee_sumamt":24,"refd_setl_flag":"0","inscp_amt":null,"mdtrt_id":"32050000000002551026","med_type":"11","fund_pay_sumamt":0,"acct_pay":0,"fix_blng_admdvs":null,"memo":"该结算数据已经对过账，且平账","setl_id":"320500000000000000000002152008","insutype":"310","stmt_rslt":"0","psn_no":"32059900000000000388476590","psn_type":"1101","setl_date":"20240617"},{"insu_admdvs":"320507","medfee_sumamt":24,"refd_setl_flag":"1","inscp_amt":null,"mdtrt_id":"32050000000002552022","med_type":"11","fund_pay_sumamt":0,"acct_pay":0,"fix_blng_admdvs":null,"memo":"该结算数据已经对过账，且平账","setl_id":"320500000000000000000002153006","insutype":"310","stmt_rslt":"0","psn_no":"32059900000000000388476590","psn_type":"1101","setl_date":"20240617"},{"insu_admdvs":"320507","medfee_sumamt":-24,"refd_setl_flag":"1","inscp_amt":null,"mdtrt_id":"32050000000002552022","med_type":"11","fund_pay_sumamt":0,"acct_pay":0,"fix_blng_admdvs":null,"memo":"该结算数据已经对过账，且平账","setl_id":"320500000000000000000002153007","insutype":"310","stmt_rslt":"0","psn_no":"32059900000000000388476590","psn_type":"1101","setl_date":"20240617"},{"insu_admdvs":"320582","medfee_sumamt":17.2,"refd_setl_flag":"1","inscp_amt":null,"mdtrt_id":"32050000000002552023","med_type":"11","fund_pay_sumamt":2.93,"acct_pay":0,"fix_blng_admdvs":null,"memo":"该结算数据已经对过账，且平账","setl_id":"320500000000000000000002153008","insutype":"390","stmt_rslt":"0","psn_no":"32059900000000000061284406","psn_type":"1501","setl_date":"20240617"},{"insu_admdvs":"320582","medfee_sumamt":-17.2,"refd_setl_flag":"1","inscp_amt":null,"mdtrt_id":"32050000000002552023","med_type":"11","fund_pay_sumamt":-2.93,"acct_pay":0,"fix_blng_admdvs":null,"memo":"该结算数据已经对过账，且定点医疗机构不存在该结算数据","setl_id":"320500000000000000000002153009","insutype":"390","stmt_rslt":"1","psn_no":"32059900000000000061284406","psn_type":"1501","setl_date":"20240617"},{"insu_admdvs":"320599","medfee_sumamt":23.6,"refd_setl_flag":"0","inscp_amt":null,"mdtrt_id":"32050000000002551027","med_type":"11","fund_pay_sumamt":4.8,"acct_pay":0,"fix_blng_admdvs":null,"memo":"该结算数据已经对过账，且平账","setl_id":"320500000000000000000002153010","insutype":"310","stmt_rslt":"0","psn_no":"32059900000000000291603780","psn_type":"1101","setl_date":"20240617"},{"insu_admdvs":"320582","medfee_sumamt":19.2,"refd_setl_flag":"0","inscp_amt":null,"mdtrt_id":"32050000000002552033","med_type":"11","fund_pay_sumamt":2.93,"acct_pay":0,"fix_blng_admdvs":null,"memo":"该结算数据已经对过账，且平账","setl_id":"320500000000000000000002153012","insutype":"390","stmt_rslt":"0","psn_no":"32059900000000000061284406","psn_type":"1501","setl_date":"20240617"},{"insu_admdvs":"320599","medfee_sumamt":23.6,"refd_setl_flag":"0","inscp_amt":null,"mdtrt_id":"32050000000002552035","med_type":"11","fund_pay_sumamt":4.8,"acct_pay":0,"fix_blng_admdvs":null,"memo":"该结算数据已经对过账，且平账","setl_id":"320500000000000000000002152011","insutype":"310","stmt_rslt":"0","psn_no":"32059900000000000291603780","psn_type":"1101","setl_date":"20240617"},{"insu_admdvs":"320599","medfee_sumamt":23.6,"refd_setl_flag":"0","inscp_amt":null,"mdtrt_id":"32050000000002552039","med_type":"11","fund_pay_sumamt":4.8,"acct_pay":0,"fix_blng_admdvs":null,"memo":"该结算数据已经对过账，且结算ID为(320500000000000000000002153013)的医疗费总额与医保中心数据不一致;医保中心的医疗费总额：23.60","setl_id":"320500000000000000000002153013","insutype":"310","stmt_rslt":"1","psn_no":"32059900000000000291603780","psn_type":"1101","setl_date":"20240617"}]}}')
  //   setPageList(info?.output)
  // },[])

  useEffect(() => {
    if (insuranceArray.length !== 0) {
      setInsuranceItem(insuranceArray[0])
    }
  }, [insuranceArray])

  // 保存医保结构体
  useEffect(() => {
    if (insuranceItem && JSON.stringify(insuranceItem) !== '{}') {
      dispatch(
        setInsurance({
          ...insuranceItem,
          userName,
          userId,
          cycleCode,
          tenantCategory,
          tenantAreaCd,
          name: tenantName,
          address: tenantAddress,
          areaCode: tenantAreaCd,
          endTime: moment(insuranceItem.endTime).format(
            DateTimeFormatSimpleOnlyOne
          ),
        })
      )
    }
    return () => {
      dispatch(setInsurance({}))
    }
  }, [insuranceItem])

  // 明细对账
  const selfDetailedReconciliationOfSettlementInfoData = (
    serverType: serverType,
    accountDate: string,
    responseString?: string
  ) => {
    setDataLoading(true)
    dispatch(
      selfDetailedReconciliationOfSettlementInfoAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          accountDate,
        },
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
              message: '明细对账',
            },
            (call: any, err) => {
              !err &&
                selfDetailedReconciliationOfSettlementInfoData(
                  'response',
                  accountDate,
                  JSON.stringify(call.netmessage)
                )
            }
          )
        } else {
          setDataLoading(false)
          setPageList(res)
        }
      })
      .catch(() => {
        setDataLoading(false)
      })
  }

  const noCardRefund = (serverType: serverType,btn : any,mdtrtId : string,setlId : string,responseString?: string) => {
    dispatch(
      noCardRefundAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          mdtrtId,
          setlId,
        },
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
              message: '无卡退费',
            },
            (call: any, err) => {
              !err &&
              noCardRefund(
                'response',
                btn,
                mdtrtId,
                setlId,
                JSON.stringify(call.netmessage)
              )
            }
          )
        } else {
          notification.success({
            message:'无卡退费成功，请重新进行明细对账'
          })
        }
      })
      // .catch(() => {
      //   btn.currentTarget.disabled = false
      // })
  }

  const exportResult = () => {
    dispatch(
      selfDetailedReconciliationOfSettlementInfoExportAsync({
        dataString: pageList || null,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '结算明细对账.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        return
      })
  }

  return (
    <div style={{ overflow: 'auto' }}>
      <Col
        style={{
          borderRadius: 10,
        }}
      >
        <Row
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '10px',
          }}
        >
          <Label
            label='本地结算费用明细'
            style={{ marginLeft: 10, fontSize: '1.125rem' }}
          />
          <Space>
            <Button
              type='primary'
              loading={dataLoading}
              onClick={() => {
                setPageList([])
                selfDetailedReconciliationOfSettlementInfoData(
                  'requestString',
                  accountDate
                )
              }}
            >
              明细对账
            </Button>
            <Button
              type='primary'
              onClick={() => {
                exportResult()
              }}
            >
              导出对账结果
            </Button>
          </Space>
        </Row>
        <EditableList
          pagination={false}
          scroll={{ y: '30rem' }}
          loading={pageLoading}
          page={{
            items: pageList?.localDetails,
            current: 1,
            size: 10,
            total: pageList?.localDetails?.length,
          }}
          rowKey={(m: any) => m.paymentId}
          columns={BDJSColumns()}
          onChangePage={(current, size) =>
            setParams({ ...params, current, size: size || 10 })
          }
          sticky
        />
      </Col>
      <Col
        style={{
          borderRadius: 10,
          marginTop: '20px',
        }}
      >
        <Row
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '10px',
          }}
        >
          <Label
            label='医药医疗机构与中心端数量一致，金额不一致'
            style={{ marginLeft: 10, fontSize: '1.125rem' }}
          />
        </Row>
        <EditableList
          pagination={false}
          scroll={{ y: '24rem' }}
          loading={pageLoading}
          page={{
            items: pageList?.compareEqualList,
            current: 1,
            size: 10,
            total: pageList?.compareEqualList?.length,
          }}
          rowKey={(m: any) => m.paymentId}
          columns={ELSEColumns('compareEqualList')}
          onChangePage={(current, size) =>
            setParams({ ...params, current, size: size || 10 })
          }
          sticky
        />
      </Col>
      <Col
        style={{
          borderRadius: 10,
          marginTop: '20px',
        }}
      >
        <Row
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '10px',
          }}
        >
          <Label
            label='医药医疗机构比中心端明细多记录'
            style={{ marginLeft: 10, fontSize: '1.125rem' }}
          />
        </Row>
        <EditableList
          pagination={false}
          scroll={{ y: '24rem' }}
          loading={pageLoading}
          page={{
            items: pageList?.compareMoreList,
            current: 1,
            size: 10,
            total: pageList?.compareMoreList?.length,
          }}
          rowKey={(m: any) => m.paymentId}
          columns={ELSEColumns('compareMoreList')}
          onChangePage={(current, size) =>
            setParams({ ...params, current, size: size || 10 })
          }
          sticky
        />
      </Col>
      <Col
        style={{
          borderRadius: 10,
          marginTop: '20px',
        }}
      >
        <Row
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            marginBottom: '10px',
          }}
        >
          <Label
            label='医药医疗机构比中心端明细少记录'
            style={{ marginLeft: 10, fontSize: '1.125rem' }}
          />
        </Row>
        <EditableList
          pagination={false}
          scroll={{ y: '24rem' }}
          loading={pageLoading}
          page={{
            items: pageList?.compareLessList,
            current: 1,
            size: 10,
            total: pageList?.compareLessList?.length,
          }}
          rowKey={(m: any) => m.paymentId}
          columns={ELSEColumns('compareLessList',(
            btn : any,
            mdtrtId : string,
            setlId : string) => {
            noCardRefund('requestString',btn,mdtrtId,setlId)
          })}
          onChangePage={(current, size) =>
            setParams({ ...params, current, size: size || 10 })
          }
          sticky
        />
      </Col>
    </div>
  )
}

export const DetailReconciliations = forwardRef(RealDetailReconciliations)
